import { render, staticRenderFns } from "./userSingle.vue?vue&type=template&id=d10aa504&scoped=true&"
import script from "./userSingle.vue?vue&type=script&lang=js&"
export * from "./userSingle.vue?vue&type=script&lang=js&"
import style0 from "./userSingle.vue?vue&type=style&index=0&id=d10aa504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10aa504",
  null
  
)

export default component.exports